import { 
  DEVICE_STATUS_TYPES 
} from '@/constants/device.js';

const deviceStatusTypesMixin = {
  computed: {
    deviceStatusTypes() {
      const deviceStatusTypesArr = [];

      for(let property in DEVICE_STATUS_TYPES) {
        deviceStatusTypesArr.push({
          value: DEVICE_STATUS_TYPES[property],
          text: this.$t(`device.statusType.${property}`)
        })
      }

      return deviceStatusTypesArr;
    },
    deviceStatusTypesWithAllSelector() {
      const deviceStatusTypesArr = [];

      deviceStatusTypesArr.push({
        text: this.$t('device.fields.allStatuses'),
        value: null
      })

      for(let property in DEVICE_STATUS_TYPES) {
        deviceStatusTypesArr.push({
          value: DEVICE_STATUS_TYPES[property],
          text: this.$t(`device.statusType.${property}`)
        })
      }

      return deviceStatusTypesArr;
    },
  }
}

export default deviceStatusTypesMixin;